<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Student Promotions</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <!-- <add-session @created="handleCreated"/> -->
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <!-- <h1>Promotions</h1>
        <div class="row card justify-content-center"> -->
      <br />
      <div class="col-xl-12">
        <a-form :form="form">
          <div class="row">
            <!-- Current Session Select -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Current Session">
                <a-select
                  v-model="selectedSession"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleSessionChange"
                  :filterOption="false"
                  :defaultValue="currentSession ? currentSession.id : ''"
                >
                  <template v-for="schoolSession in schoolSessions">
                    <a-select-option
                      :value="schoolSession.id"
                      :key="schoolSession.id"
                    >
                      {{ schoolSession.name }}
                      <small
                        class="text-primary ml-2"
                        v-if="schoolSession.is_current === 1"
                        >Current</small
                      >
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </div>
            <!-- Next Session Select -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Promote to Session">
                <a-select
                  placeholder="Select session"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleNextSessionChange"
                >
                  <template v-for="schoolSession in schoolSessions">
                    <a-select-option
                      :value="schoolSession.id"
                      :key="schoolSession.id"
                    >
                      {{ schoolSession.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </div>
            <!-- Class Select -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Promote from Class">
                <a-spin :spinning="classSpinning">
                  <a-select
                    size="default"
                    v-model="selectedClass"
                    placeholder="Current class"
                    style="width: 100%"
                    @change="handleClassSelect"
                    :defaultValue="undefined"
                  >
                    <template v-for="schoolClass in schoolClasses">
                      <a-select-option
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Next Class Select -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Promote to Class">
                <a-spin :spinning="classNextSpinning">
                  <a-select
                    size="default"
                    v-model="selectedNextClass"
                    placeholder="Select class"
                    style="width: 100%"
                    @change="handleNextClassSelect"
                    :defaultValue="undefined"
                  >
                    <template v-for="schoolClass in schoolNextClasses">
                      <a-select-option
                        :value="schoolClass.id"
                        :key="schoolClass.id"
                      >
                        {{ schoolClass.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Current Section -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Promote from Section">
                <a-spin :spinning="sectionSpinning">
                  <a-select
                    size="default"
                    v-model="selectedSection"
                    placeholder="Select current Section"
                    style="width: 100%"
                    @change="handleSectionChange"
                    :defaultValue="undefined"
                  >
                    <template v-for="classSection in classSections">
                      <a-select-option
                        :value="classSection.id"
                        :key="classSection.id"
                      >
                        {{ classSection.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <!-- Next Section -->
            <div class="col-md-3 mb-2">
              <a-form-item label="Promote to Section">
                <a-spin :spinning="sectionNextSpinning">
                  <a-select
                    size="default"
                    v-model="selectedNextSection"
                    placeholder="Select current Section"
                    style="width: 100%"
                    @change="handleNextSectionChange"
                    :defaultValue="undefined"
                  >
                    <template v-for="classSection in classNextSections">
                      <a-select-option
                        :value="classSection.id"
                        :key="classSection.id"
                      >
                        {{ classSection.name }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-spin>
              </a-form-item>
            </div>
            <div class="col-md-3 mb-2"></div>
            <!-- Promote manage button -->
            <div class="col-md-3 mb-2 text-right" style="margin-top:27px">
              <a-button type="primary" @click="handle_promotion">
                Manage Promotions
              </a-button>
            </div>
          </div>
        </a-form>
        <hr />
      </div>
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <student-list-table
              :details="collectionData"
              :promote_to_class="selectedNextClass"
              :promote_to_section="selectedNextSection" />
          </div>
        </div>
        <!-- <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div> -->
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
    <!-- <br><br><br>
    <div class="col-xl-12">
        <div class="col-md-12 mb-2 text-center">No data found!</div>
    </div> -->
  </div>
</template>

<script>
import StudentListTable from '@/components/promotion/Table/index'
// import AddSession from '@/components/session/Forms/Add/index'
// import { mapState } from 'vuex'

export default {
  components: {
    StudentListTable,
    // AddSession,
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function(val) {
      this.selectedSession = val.id
    },
    selectedNextSession: function(val) {
      return val
    },
    classSections: function(val) {
      return val
    },
    selectedClass: function(val) {
      return val
    },
    selectedNextClass: function(val) {
      return val
    },
    selectedNext: function(val) {
      return val
    },
    selectedSection: function(val) {
      return val
    },
    selectedNextSection: function(val) {
      return val
    },
    collectionData: function(val) {
      return val
    },
    studentDetails: function(val) {
      return val
    },
  },
  mounted: function() {
    this.$http
      .get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        // this.selectedSession = find(data.data, ['is_current', 1]).id
        this.selectedSession = this.schoolSessions.filter(
          obj => obj.is_current === 1
        )[0].id
        this.getClasses(this.selectedSession)
      })
      .catch(error => {
        console.log(error)
      })
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      classSpinning: false,
      classNextSpinning: false,
      sectionSpinning: false,
      sectionNextSpinning: false,
      classSections: [],
      classNextSections: [],
      promotionStatus: [],
      schoolClasses: [],
      schoolNextClasses: [],
      data: [],
      meta: {},
      collectionData: [],
      current: 1,
      pageSize: 30,
      schoolSessions: [],
      selectedSession: undefined,
      selectedNextSession: undefined,
      selectedClass: undefined,
      selectedNextClass: undefined,
      selectedSection: undefined,
      selectedNextSection: undefined,
      studentDetails: {},
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('promotion', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  methods: {
    handle_promotion() {
      this.$http
        .get('/api/promotion/students', {
          params: {
            from_session_id: this.selectedSession,
            from_class_id: this.selectedClass,
            from_section_id: this.selectedSection,
            to_session_id: this.selectedNextSession,
            // limit: this.pageSize,
            // page: this.current,
          },
        })
        .then(({ data }) => {
          this.studentDetails = data.data
          this.collectionData = [
            {
              current_session: this.currentSession,
              nextSession: this.selectedNextSession,
              current_class: this.selectedClass,
              next_class: this.selectedNextClass,
              current_section: this.selectedSection,
              next_section: this.selectedNextSection,
              promote_classs: this.schoolNextClasses, // Class list for the next session
              promote_sections: this.classNextSections, // Section list for the next session
              students: data.data,
            },
          ]
        })
      // alert('Under development!')
    },
    handleSessionChange(value) {
      this.selectedClass = undefined
      this.selectedNextClass = undefined
      if (value) {
        this.selectedSession = value
        this.getClasses(value)
      } else {
        this.selectedSession = this.currentSession
        this.getClasses(this.selectedSession)
      }
      // this.getClassSectionExam()
    },
    handleNextSessionChange(id) {
      this.selectedNextSection = undefined
      this.selectedNextClass = undefined
      if (id) {
        this.selectedNextSession = id
        this.getNextClasses(id)
      }
    },
    getClasses: function(id) {
      this.classSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: id,
          },
        })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSections = undefined
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getNextClasses: function(id) {
      this.classNextSpinning = true
      this.$http
        .get('/api/class', {
          params: {
            session_id: id,
          },
        })
        .then(({ data }) => {
          this.schoolNextClasses = data.data
          this.classNextSections = undefined
          this.classNextSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getClassSection: function(id) {
      this.sectionSpinning = true
      this.$http
        .get(`/api/section/class/${id}`, {
          params: {
            session_id: this.selectedSession,
          },
        })
        .then(({ data }) => {
          this.classSections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getNextClassSection: function(id) {
      this.sectionNextSpinning = true
      this.$http
        .get(`/api/section/class/${id}`, {
          params: {
            session_id: this.selectedNextSession,
          },
        })
        .then(({ data }) => {
          this.classNextSections = data.data
          this.sectionNextSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      this.selectedClass = value
      this.classSections = []
      this.getClassSection(this.selectedClass)
    },
    handleNextClassSelect(value) {
      this.selectedNextSection = undefined
      this.selectedNextClass = value
      this.getNextClassSection(value)
    },
    handleSectionChange(value) {
      this.selectedSection = value
    },
    handleNextSectionChange(value) {
      this.selectedNextSection = value
    },
  },
}
</script>
